import { Config } from './config.interface';

export const stagingConfig: Config = {
  privyAppId: 'clvl2h3t4009z4zhrp83gopvn',
};
